import { GuxTagAccent } from "genesys-spark-components";
import { ReactNode } from "react";

import { GuxBadge, GuxTag } from "genesys-spark-components-react";

export type ScoreTagLevel = "default" | "critical" | "info" | "fatal";

// TODO: update the colour accent number when doing full migration
const colors: { [key in ScoreTagLevel]?: GuxTagAccent } = {
    default: "4",
    critical: "8",
    info: "1",
    fatal: undefined,
};

export function ScoreTag({
    children,
    mode = "default",
    selected = true,
}: {
    children: ReactNode;
    mode?: ScoreTagLevel;
    selected?: boolean;
}) {
    return mode === "fatal" ? (
        <GuxBadge accent="error" bold={selected} className="ScoreTag">
            {children}
        </GuxBadge>
    ) : (
        <GuxTag
            className="ScoreTag"
            accent={colors[mode]}
            emphasis={selected ? "bold" : "subtle"}
        >
            {children}
        </GuxTag>
    );
}
